export function fmtDateIL(ms) {
  if (!ms) return "";
  return new Date(ms).toLocaleDateString("en-GB", {
    timeZone: "Asia/Jerusalem",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}

export function fmtTimeIL(ms) {
  if (!ms) return "";
  return new Date(ms).toLocaleTimeString("en-GB", {
    timeZone: "Asia/Jerusalem",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

export function fmtSize(bytes) {
  if (!bytes) return "";
  const mb = bytes / 1048576;
  return mb >= 1024 ? `${(mb / 1024).toFixed(1)} GB` : `${Math.round(mb)} MB`;
}

// recordings/<YYYY-MM-DD>/<HHMM>-<HHMM>_<run_id>.mp4 — the fallback when the
// sidecar JSON is missing (older recordings, or a save that half-failed). The
// same layout is parsed by the server (recordings.service windowFromKey) and
// written by the container (recording_s3.key_for); all three must agree.
const KEY_RE = /recordings\/(\d{4})-(\d{2})-(\d{2})\/(\d{2})(\d{2})-(\d{2})(\d{2})_/;

export function describe(item) {
  const meta = item.meta;
  if (meta?.record_start_utc_ms) {
    return {
      date: fmtDateIL(meta.record_start_utc_ms),
      window: `${fmtTimeIL(meta.record_start_utc_ms)}–${fmtTimeIL(meta.record_end_utc_ms)}`,
    };
  }
  const m = KEY_RE.exec(item.key || "");
  if (!m) return { date: "", window: "" };
  return {
    date: `${m[3]}/${m[2]}/${m[1]}`,
    window: `${m[4]}:${m[5]}–${m[6]}:${m[7]}`,
  };
}
